//
// Helpers para o contrato canônico de validação de regras de carga horária
// (POST /working-hours-rules/validate). Usados pelo AddUserToScaleModal (validação
// no clique de atribuição) e pelo EditScale (validação pré-disparo da grade).
//
// Nota: difere do durationToMinutes de @/mixins/utils, que aceita apenas "HH:MM".
// Os turnos da grade guardam duração em HORAS (número ou string numérica) e às
// vezes "HH:MM" — este helper aceita os três formatos.
//

// Converte duração em horas (número, string numérica ou "HH:MM") para minutos
export const durationHoursToMinutes = (duration) => {
  if (typeof duration === 'number') return Math.round(duration * 60)

  const str = String(duration || '').trim()

  if (str.includes(':')) {
    const [h, m] = str.split(':')
    return ((parseInt(h, 10) || 0) * 60) + (parseInt(m, 10) || 0)
  }

  const num = parseFloat(str)
  return isNaN(num) ? 0 : Math.round(num * 60)
}

// Monta ISO-8601 (UTC) a partir de data "YYYY-M-D" ou "YYYY-MM-DD" + hora "HH:MM" no fuso local
export const buildStartAtISO = (dateYYYYMD, timeHHMM) => {
  const [y, m, d] = String(dateYYYYMD).split('-').map(p => parseInt(p, 10))
  const [hh, mm] = String(timeHHMM).split(':').map(p => parseInt(p, 10) || 0)
  return new Date(y, (m - 1), d, hh, mm, 0).toISOString()
}

// candidate_id da proposta sendo adicionada no clique (para filtrar violações relevantes)
export const NEW_PROPOSAL_CANDIDATE_ID = 'new-proposal'
